<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <v-tabs color="transparent">
        <v-tab
          v-for="item in accountSettings"
          :to="{name: item.routeName}"
          :key="item.name">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider/>
      <v-flex>
        <router-view/>
      </v-flex>
    </v-card>
  </app-layout>
</template>

<script>
export default {
  name: 'Settings',
  computed: {
    accountSettings () {
      return [
        { name: this.$t('personalInfo'), routeName: 'personalInfoSettings' },
        { name: this.$t('email'), routeName: 'emailSettings' },
        { name: this.$t('password'), routeName: 'passwordSettings' },
        { name: this.$t('gdpr'), routeName: 'gdprSettings' }
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        email: 'Change email',
        gdpr: 'GDPR',
        heading: 'Settings',
        password: 'Password',
        personalInfo: 'Personal Data'
      },
      tr: {
        email: 'E-postayı değiştir',
        gdpr: 'GDPR',
        heading: 'Ayarlar',
        password: 'Şifre',
        personalInfo: 'Kişisel Veri'
      },
      de: {
        email: 'Email ändern',
        gdpr: 'DSGVO',
        heading: 'Einstellungen',
        password: 'Passwort ändern',
        personalInfo: 'Persönliche Daten'
      },
      ru: {
        email: 'Изменить эл. адрес',
        gdpr: 'GDPR',
        heading: 'Настройки',
        password: 'Пароль',
        personalInfo: 'Персональные данные'
      }
    }
  }
}
</script>
